import { render, staticRenderFns } from "./ProfileView.html?vue&type=template&id=3a2cd3aa&scoped=true&"
import script from "./ProfileView.vue?vue&type=script&lang=js&"
export * from "./ProfileView.vue?vue&type=script&lang=js&"
import style0 from "./ProfileView.scss?vue&type=style&index=0&id=3a2cd3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2cd3aa",
  null
  
)

export default component.exports